import { Wizard } from "react-use-wizard";
import SelectHCProvider from "./selectHCProvider";
import SelectClinicStep from "./selectClinic";
import SelectDayStep from "./selectDay";
import SelectTimeStep from "./selectTime";
import ConfirmAppointmentStep from "./confirmAppointment";
import ConfirmWaitlistStep from "./confirmWaitlist";
import FinalConfirmWaitingListStep from "./finalConfirmWaitingList";
import { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import React, { useEffect } from "react";
import createPersistedState from "use-persisted-state";
import { useTranslation } from "react-i18next";
import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import SelectDoctor from "./selectDoctor";

const useTokenState = createPersistedState("token");

function AppointmentWizard({
  currentSlot,
  setCurrentSlot,
  id,
  isReschedule,
  attendDetail,
}) {
  const [currentDate, setCurrentDate] = useState();
  const [selectedClinic, setSelectedClinic] = useState();
  const [availableClinics, setAvailableClinics] = useState();
  const location = useLocation();
  const [recDate, setRecDate] = useState();
  const [recDoctor, setRecDoctor] = useState();
  const [patientDefaultClinic, setPatientDefaultClinic] = useState();
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [doctorClinicData, setDoctorClinicData] = useState(null);

  const searchParams = new URLSearchParams(location.search);
  const recDateQueryParam = searchParams.get("recDate");
  const isDietInfoRecentlyFilled = new URLSearchParams(location.search).get(
    "dietInfoFilled"
  );

  const { t } = useTranslation();
  const history = useHistory();

  const [token, _] = useTokenState();

  const patientId = JSON.parse(localStorage.getItem("pid"));

  const USER_PROFILE_URL = `/api/v1/users/profile/${patientId}`;
  const DOCTOR_CLINIC_URL = `/api/v1/users/register/settings`;

  useEffect(() => {
    if (location.state?.recDate != null || recDateQueryParam != null) {
      setRecDate(location?.state?.recDate || recDateQueryParam);
    }
  }, [location.state, recDateQueryParam]);

  useEffect(() => {
    if (!token) return;
    //return early if coming from diet info filled flow as we need to continue dietitian booking flow and below code will override the recDoctor and clinic selection
    if (isDietInfoRecentlyFilled) return;
    //For reschedule Flow
    if (isReschedule && attendDetail) {
      setRecDoctor({
        drName: attendDetail.ownerMetadata.name,
        drId: attendDetail.ownerMetadata.code,
      });
      setPatientDefaultClinic(attendDetail.spaceMetadata.code);
      return;
    }

    const fetchUserProfile = async () => {
      setIsFetchingData(true);
      try {
        const response = await fetch(USER_PROFILE_URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });

        const data = await response.json();

        if (data?.status?.code === 200) {
          setRecDoctor({
            drName: data.profile.doctorName,
            drId: data.profile.doctorId,
          });

          setPatientDefaultClinic(data.profile?.clinicId);
        }
      } catch (e) {
        console.error("User profile fetch failed", e);
      }
    };

    fetchUserProfile();
  }, [token]);
  useEffect(() => {
    if (!token) return;

    const fetchDoctorClinics = async () => {
      try {
        const response = await fetch(DOCTOR_CLINIC_URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });

        const data = await response.json();

        if (data?.status?.code === 200) {
          setDoctorClinicData(data);
        }
      } catch (e) {
        console.error("Doctor clinic fetch failed", e);
      } finally {
        setIsFetchingData(false);
      }
    };

    fetchDoctorClinics();
  }, [token]);

  useEffect(() => {
    if (!doctorClinicData || !recDoctor?.drId) return;

    const clinics =
      doctorClinicData.doctors.find((doc) => doc.code === recDoctor.drId)
        ?.clinics || [];

    setAvailableClinics(clinics);
  }, [recDoctor, doctorClinicData]);

  return isFetchingData ? (
    <>
      <NavigateBackWizardStep
        clickHandler={() => history.push("/my-appointments")}
        title={t("appointment.DOCTOR.topHeading")}
      />
      <div className="body_content p-0">
        <div className="inner_body">
          <div
            style={{
              margin: "auto",
              marginTop: "10em",
              display: "flex",
              justifyContent: "center",
            }}
            id="loader"
          ></div>
        </div>
      </div>
    </>
  ) : (
    <>
      <Wizard startIndex={0}>
        {/* <SelectHCProvider
          selectClinic={setSelectedClinic}
          setRecDoctor={setRecDoctor}
          attendDetail={attendDetail}
        /> */}
        <SelectDoctor
          selectedClinic={selectedClinic}
          selectClinic={setSelectedClinic}
          recDoctor={recDoctor}
          setRecDoctor={setRecDoctor}
        />
        <SelectClinicStep
          selectClinic={setSelectedClinic}
          availableClinics={availableClinics}
          patientDefaultClinic={patientDefaultClinic}
        />
        <SelectDayStep
          setCurrentDate={setCurrentDate}
          selectedClinic={selectedClinic}
          availableClinics={availableClinics}
          recDate={recDate}
          recDoctor={recDoctor}
          setRecDate={setRecDate}
          isReschedule={isReschedule}
        />
        <SelectTimeStep
          setCurrentSlot={setCurrentSlot}
          currentDate={currentDate}
          selectedClinic={selectedClinic}
          availableClinics={availableClinics}
          recDoctor={recDoctor}
          isReschedule={isReschedule}
        />
        <ConfirmAppointmentStep
          currentSlot={currentSlot}
          id={id}
          isReschedule={isReschedule}
          selectedClinic={selectedClinic}
          recDoctor={recDoctor}
        />
        <ConfirmWaitlistStep currentDate={currentDate} />
        <FinalConfirmWaitingListStep currentDate={currentDate} />
      </Wizard>
    </>
  );
}

export default AppointmentWizard;
